import React, { Fragment, useMemo } from 'react';
import AppTable from '../../../../constants/AppTable';
import Container from '../../../../constants/Container';
import { LoadingSpinner } from '../../../../constants/AppLoading';

interface Author {
    first_name: string;
    last_name: string;
    username: string;
    email: string;
    phone_number: string;
    designation: string;
    user_locked: number;
}

interface AuthorTableListViewProps {
    data: {
        results: Author[];
        previous: string | null;
        next: string | null;
    } | null;
    loading: boolean;
    error: string | null;
    setOnURL: React.Dispatch<React.SetStateAction<string>>;
}

const AuthorTableListView: React.FC<AuthorTableListViewProps> = ({ data, loading, error, setOnURL }) => {

    const columns = [
        { header: 'Name', accessor: 'name', sortable: true },
        { header: 'Username', accessor: 'username', sortable: true },
        { header: 'Email', accessor: 'email', sortable: true },
        { header: 'Phone No.', accessor: 'phone_no', sortable: true },
        { header: 'Designation', accessor: 'designation', sortable: true },
        { header: 'Locked', accessor: 'locked', sortable: true },
    ];

    const modifiedData = useMemo(() => {
        if (!data) return [];
        return data.results.map((item: Author) => ({
            name: `${item.first_name} ${item.last_name}`,
            username: item.username,
            email: item.email,
            phone_no: item.phone_number,
            designation: item.designation,
            locked: item.user_locked === 1 ? "Yes" : "No",
        }));
    }, [data]);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <LoadingSpinner />
            </div>
        );
    }

    if (error) {
        return <p>Error loading data: {error}</p>;
    }

    return (
        <Fragment>
            <Container padding={false}>
                <AppTable 
                    columns={columns} 
                    data={modifiedData}
                    onNext={() => data?.next && setOnURL(data.next)} 
                    onPrev={() => data?.previous && setOnURL(data.previous)} 
                />
            </Container>
        </Fragment>
    );
};

export default AuthorTableListView;
